const t = {
  name: "WhiteBoard",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30,21h6v2h-6V21z"/>
		<path class="st0" d="M21,3h16c1.7,0,3,1.3,3,3v18c0,1.7-1.3,3-3,3H26.9l3.3,13h-2.1l-3.3-13H21v13h-2V27h-3.7L12,40H10l3.2-13H3
			c-1.7,0-3-1.3-3-3V6c0-1.7,1.3-3,3-3h16V0h2V3z M2,6v18c0,0.6,0.4,1,1,1h34c0.6,0,1-0.4,1-1V6c0-0.6-0.4-1-1-1H3C2.4,5,2,5.4,2,6z
			"/>
	</g>
</g>
</svg>
  `
};
export {
  t as WhiteBoard
};
